import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import globals from "../../globals";
import Icon from "../Icon";

function Sidebar() {
  const sidebarRef = useRef(null);
  const layoutMenuRef = useRef(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 1200);
    };
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    layoutMenuRef.current = document.querySelector(".layout-menu");
  }, []);

  const togglemobileMenu = () => {
    const htmlElement = document.documentElement;

    htmlElement.classList.remove("layout-menu-expanded");
  };

  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  useEffect(() => {
    if (isMobileView) {
      const handleClickOutside = (event) => {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
          togglemobileMenu(); // Close the sidebar
        }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isMobileView, togglemobileMenu]);

  return (
    <>
      <aside
        id="layout-menu"
        className={`layout-menu menu-vertical menu bg-menu-theme`}
        ref={sidebarRef}
      >
        <div className="app-brand demo">
          <a
            href="/dashboard"
            className="app-brand-link"
            style={{ height: "100%" }}
          >
            <img
              src="/images/logo.png"
              alt="Invitd"
              style={{ height: "100%" }}
            />
          </a>
        </div>
        <div className="menu-inner-shadow"></div>
        <ul className="menu-inner py-3">
          <NavLink
            to="/dashboard"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active open" : ""}`
            }
          >
            <span className="menu-link" onClick={togglemobileMenu}>
              <Icon name={globals.dashboard.icon} size={18} className="me-2" />
              <div>{globals.dashboard.title}</div>
            </span>
          </NavLink>

          <NavLink
            to="/invitations"
            className={({ isActive }) =>
              `menu-item  ${isActive ? "active open" : ""}  `
            }
          >
            <span className="menu-link" onClick={togglemobileMenu}>
              <Icon
                name={globals.myInvitations.icon}
                size={18}
                className="me-2"
              />
              <div>{globals.myInvitations.title}</div>
            </span>
          </NavLink>

          <NavLink
            to="/create-invitation"
            className={({ isActive }) =>
              `menu-item  ${isActive ? "active open" : ""}  `
            }
          >
            <span className="menu-link" onClick={togglemobileMenu}>
              <Icon
                name={globals.createInvitation.icon}
                size={18}
                className="me-2"
              />
              <div>{globals.createInvitation.title}</div>
            </span>
          </NavLink>

          <NavLink
            to="/demos"
            className={({ isActive }) =>
              `menu-item  ${isActive ? "active open" : ""}  `
            }
          >
            <span className="menu-link" onClick={togglemobileMenu}>
              <Icon name={globals.mydemos.icon} size={18} className="me-2" />
              <div>{globals.mydemos.title}</div>
            </span>
          </NavLink>

          <NavLink
            to="/create-demo"
            className={({ isActive }) =>
              `menu-item  ${isActive ? "active open" : ""}  `
            }
          >
            <span className="menu-link" onClick={togglemobileMenu}>
              <Icon name={globals.createDemo.icon} size={18} className="me-2" />
              <div>{globals.createDemo.title}</div>
            </span>
          </NavLink>


          <NavLink
            to="/profile"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active open" : ""}`
            }
          >
            <span className="menu-link" onClick={togglemobileMenu}>
              <Icon name={globals.profile.icon} size={18} className="me-2" />
              <div>{globals.profile.title}</div>
            </span>
          </NavLink>

          <NavLink
            to="/mystudios"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active open" : ""}`
            }
          >
            <span className="menu-link" onClick={togglemobileMenu}>
              <Icon name={globals.myStudios.icon} size={18} className="me-2" />
              <div>{globals.myStudios.title}</div>
            </span>
          </NavLink>

          <NavLink
            to="/addons"
            className={({ isActive }) =>
              `menu-item ${isActive ? "active open" : ""}`
            }
          >
            <span className="menu-link" onClick={togglemobileMenu}>
              <Icon name={globals.addons.icon} size={18} className="me-2" />
              <div>{globals.addons.title}</div>
            </span>
          </NavLink>



          <li className="menu-item">
            <NavLink
              className={({ isActive }) =>
                `menu-link  menu-toggle ${isActive ? "active open" : ""}`
              }
              onClick={toggleSubMenu}
            >
              <Icon name={globals.settings.icon} size={18} className="me-2" />
              <div>{globals.settings.title}</div>
            </NavLink>
            <ul className={` ${!isSubMenuOpen ? "menu-sub" : ""}`}>
              {/* <NavLink to="/" className={({ isActive }) => `menu-item ${isActive ? "active open" : ""}`} >
                <span className="menu-link" onClick={togglemobileMenu}>
                  <Icon name={globals.myoneqr.icon} size={18} className="me-2" />
                  <div>{globals.myoneqr.title}</div>
                </span>
              </NavLink> */}

              <NavLink
                to="/create-website"
                className={({ isActive }) =>
                  `menu-item  ${isActive ? "active open" : ""}  `
                }
              >
                <span className="menu-link" onClick={togglemobileMenu}>
                  <Icon
                    name={globals.createWebsite.icon}
                    size={18}
                    className="me-2"
                  />
                  <div>{globals.createWebsite.title}</div>
                </span>
              </NavLink>

              <NavLink
                to="/domains"
                className={({ isActive }) =>
                  `menu-item  ${isActive ? "active open" : ""}  `
                }
              >
                <span className="menu-link" onClick={togglemobileMenu}>
                  <Icon
                    name={globals.domains.icon}
                    size={18}
                    className="me-2"
                  />
                  <div>{globals.domains.title}</div>
                </span>
              </NavLink>

              <NavLink
                to="/myqrcode"
                className={({ isActive }) =>
                  `menu-item  ${isActive ? "active open" : ""}  `
                }
              >
                <span className="menu-link" onClick={togglemobileMenu}>
                  <Icon
                    name={globals.myoneqr.icon}
                    size={18}
                    className="me-2"
                  />
                  <div>{globals.myoneqr.title}</div>
                </span>
              </NavLink>

              <NavLink
                to="/plans"
                className={({ isActive }) =>
                  `menu-item ${isActive ? "active open" : ""}`
                }
              >
                <span className="menu-link" onClick={togglemobileMenu}>
                  <Icon name={globals.myplan.icon} size={18} className="me-2" />
                  <div>{globals.myplan.title}</div>
                </span>
              </NavLink>

              <NavLink
                to="/downloads"
                className={({ isActive }) =>
                  `menu-item ${isActive ? "active open" : ""}`
                }
              >
                <span className="menu-link" onClick={togglemobileMenu}>
                  <Icon name={globals.downloads.icon} size={18} className="me-2" />
                  <div>{globals.downloads.title}</div>
                </span>
              </NavLink>
            </ul>
          </li>
        </ul>
      </aside>
      {/* <!-- Overlay --> */}
      <div className="layout-overlay layout-menu-toggle"></div>

      {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
      <div className="drag-target"></div>
    </>
  );
}

export default Sidebar;
